import type React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { View } from "shared/containers/View";

import { PatientList } from "./components/PatientList";

export const PartnerDashboard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <View title={t("views.dashboard")} description={t("views.dashboard_description")} hideBreadcrumbs>
      <Stack spacing={{ xs: 2, md: 4 }} mb={4}>
        <PatientList />
      </Stack>
    </View>
  );
};
